module.exports = __webpack_public_path__ + "files/aad893d3c8c372886f23d5f9a3ecde56.png";